export interface Toast {
  id: number;
  title: string;
  sub?: string;
}

type Listener = (toasts: Toast[]) => void;

let toasts: Toast[] = [];
let nextId = 1;
const listeners = new Set<Listener>();

export function toast(title: string, sub?: string): void {
  const t: Toast = { id: nextId++, title, sub };
  toasts = [...toasts, t];
  emit();
  setTimeout(() => {
    toasts = toasts.filter((x) => x.id !== t.id);
    emit();
  }, 4200);
}

export function subscribeToasts(fn: Listener): () => void {
  listeners.add(fn);
  return () => listeners.delete(fn);
}

export function getToasts(): Toast[] {
  return toasts;
}

function emit(): void {
  for (const fn of listeners) fn(toasts);
}
